<template>
  <v-container fluid class="container">
    <!-- <v-layout wrap class="container" px-0 pb-0>
    <v-flex> -->
    <!-- <v-row pt-12 no-gutters class="ipad_res"> -->
    <v-row>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6" xxl="6">
        <p class="text-center columntextcolor">
          {{ "ลงทะเบียนเพื่อทดลองการใช้งานฟรี!!" }}
        </p>
        <v-card
          style="max-width: 523px; max-height: 437px; margin-top: 20px"
          elevation="0"
          class="mx-auto"
          color="#F3F6FB"
        >
          <v-img src="@/assets/imgs/registerimage2.png" />
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="6" xl="6" xxl="6">
        <v-flex px-2>
          <p class="text-left columntextcolor">
            {{ "เริ่มต้นง่าย ติดตั้งง่าย" }}
          </p>
        </v-flex>
        <v-col cols="12">
          <v-layout row wrap>
            <v-flex class="lg10 md12 xs12 sm12" px-3>
              <label for="inputCompany" class="b-text LableFontDesing">
                ชื่อบริษัท
                <span style="color: red">*</span>
              </label>
              <input
                type="text"
                ref="companyName"
                class="form-control LablePlaceHolder"
                id="inputCompany"
                placeholder="ชื่อบริษัท"
                v-model="companyName"
                style="border: 1px #707070; border-radius: 5px; height: 50px"
              />
              <div v-if="namecheck" style="color: red" class="text">
                {{ $t("needcompanyname") }}
              </div>
              <div
                v-if="checkalphabet2 == true"
                style="color: red"
                class="text"
              >
                {{ $t("IsAlphabet") }}
              </div>
            </v-flex>
            <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
              <label for="inputCompany" class="b-text LableFontDesing">
                รหัสบริษัท (ภาษาอังกฤษหรือตัวเลขที่ไม่เกิน 5 ตัวอักษร เช่น
                KM001)
                <span style="color: red">*</span>
              </label>
              <input
                type="text"
                class="form-control LablePlaceHolder"
                placeholder="รหัสบริษัท"
                @keypress="checkAlphabet"
                @paste="onPaste($event)"
                v-model="abbr"
                maxlength="5"
                style="border: 1px #707070; border-radius: 5px; height: 50px"
              />
              <div v-if="checkalphabet == true" style="color: red" class="text">
                {{ $t("IsNumberAlaphabet") }}
              </div>
              <div v-if="abbrevCheck" style="color: red" class="text">
                {{ $t("needcompanycode") }}
              </div>
            </v-flex>
            <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
              <label for="inputTelephone" class="b-text LableFontDesing">
                หมายเลขโทรศัพท์
                <span style="color: red">*</span>
              </label>
              <input
                type="text"
                class="form-control LablePlaceHolder"
                id="inputTelephone"
                placeholder="หมายเลขโทรศัพท์"
                @keydown="isNumber($event)"
                v-model="telephoneNumber"
                v-mask="'###########'"
                style="border: 1px #707070; border-radius: 5px; height: 50px"
              />
              <div v-if="checknumber == true" style="color: red" class="text">
                {{ $t("IsNumber") }}
              </div>
              <div v-if="phonecheck" style="color: red" class="text">
                {{ $t("needTel") }}
              </div>
              <div v-if="phonenolength" style="color: red" class="text">
                {{ $t("enterphno") }}
              </div>
            </v-flex>
            <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
              <label for="inputEmail" class="b-text LableFontDesing">
                {{ $t("email") }}
                <span style="color: red">*</span>
              </label>
              <input
                type="text"
                class="form-control LablePlaceHolder"
                id="inputEmail"
                placeholder="อีเมล"
                v-model="email"
                style="border: 1px #707070; border-radius: 5px; height: 50px"
              />
              <div v-if="mailcheck" style="color: red" class="text">
                {{ $t("EnterCorrect") }}
              </div>
            </v-flex>

            <!-- <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
                <label for="inputpackagename" class="b-text LableFontDesing">
                  ประเทศ
                  <span style="color: red">*</span>
                </label>
                <v-select
                  dense
                  flat
                  v-model="countryName"
                  solo
                  style="border-radius: 5px !important"
                  :items="filteredThaiCountryNames"
                  :item-text="(item) => item.thaiCountryName"
                  :item-value="(item) => item.thaiCountryName"
                >
                  <template v-slot:prepend-item>
                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field
                          v-model="searchCountry"
                          :placeholder="searchCountry"
                          @input="searchInLists"
                          autocomplete="off"
                          hide-details
                          class="searchinlist"
                          append-icon="mdi-magnify"
                        ></v-text-field>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-select>
                <div v-if="countrycheck" style="color: red" class="text">
                  จำเป็นต้องระบุประเทศ
                </div>
              </v-flex>
              <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
                <label for="inputCity" class="b-text LableFontDesing">
                  {{ $t("city") }}
                  <span style="color: red">*</span>
                </label>
                <input
                  type="text"
                  class="form-control LablePlaceHolder"
                  id="inputCity"
                  placeholder="จังหวัด"
                  v-model="cityName"
                  style="border: 1px #707070; border-radius: 5px; height: 50px"
                />
                <div v-if="citycheck" style="color: red" class="text">
                  {{ $t("needcity") }}
                </div>
              </v-flex> -->
            <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
              <label for="inputContactName" class="b-text LableFontDesing">
                {{ "ชื่อผู้ติดต่อใช้งาน" }}
                <span style="color: red">*</span>
              </label>
              <input
                type="text"
                class="form-control LablePlaceHolder"
                id="inputContactName"
                placeholder="ชื่อผู้ติดต่อใช้งาน"
                v-model="contactName"
                style="border: 1px #707070; border-radius: 5px; height: 50px"
              />
              <div v-if="contactnamecheck" style="color: red" class="text">
                {{ "กรุณากรอกชื่อผู้ติดต่อใช้งาน" }}
              </div>
            </v-flex>
            <!-- <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
                <label for="inputAddress" class="b-text LableFontDesing">
                  {{ $t("address") }}
                  <span style="color: red">*</span>
                </label>
                <textarea
                  type="text"
                  class="form-control LablePlaceHolder"
                  id="inputAddress"
                  placeholder="ที่อยู่บริษัท"
                  @keydown="IsSpecialCharAddress($event)"
                  v-model="address"
                  rows="5"
                  style="border: 1px #707070; border-radius: 5px; height: 150px"
                ></textarea>
                <div v-if="addresscheck" style="color: red" class="text">
                  {{ $t("needaddress") }}
                </div>
              </v-flex> -->
            <!-- <v-flex class="lg10 md12 xs12 sm12">
                <v-row class="ml-3">
                  <div class="col-lg-12 form-group clear mt-4 pr-5 pl-0">
                    <label
                      for="inputpackagename"
                      class="b-text LableFontDesing"
                    >
                      {{ $t("businesstype") }}
                      <span style="color: red">*</span>
                    </label>
                    <v-select
                      dense
                      flat
                      v-model="businessTypeID"
                      solo
                      style="border-radius: 5px !important"
                      :items="filteredNames"
                      @change="handleOptionChange(businessTypeID)"
                      item-text="thai_Name"
                      item-value="id"
                    >
                      <template v-slot:prepend-item>
                        <v-list-item>
                          <v-list-item-content>
                            <v-text-field
                              v-model="search"
                              :placeholder="$t('search')"
                              @input="searchInLists"
                              autocomplete="off"
                              hide-details
                              class="searchinlist"
                              append-icon="mdi-magnify"
                            ></v-text-field>
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select>
                    <div v-if="businesscheck" style="color: red" class="text">
                      {{ $t("businesstype") }} is required
                    </div>
                  </div>
                  <div class="col-lg-12 form-group clear mt-4 pr-5 pl-2">
                    <label
                      for="inputactiveemployees"
                      class="b-text LableFontDesing"
                      v-if="this.otheroptions == true || showField"
                    >
                      {{ $t("otheroptionsfield") }}

                      <span style="color: red">*</span>
                    </label>
                    <v-text-field
                      solo
                      dense
                      flat
                      v-if="this.otheroptions == true || showField"
                      type="text"
                      id="inputcontactname"
                      :placeholder="otheroptionstype()"
                      v-model="businessTypeOther"
                    ></v-text-field>
                    <div
                      v-if="otherbusinesscheck && this.otheroptions == true"
                      style="color: red"
                      class="text"
                    >
                      {{ $t("businesstype") }} is required
                    </div>
                  </div>
                </v-row>
              </v-flex> -->

            <v-flex class="lg10 md12 xs12 sm12" pt-5 px-3>
              <label
                for="inputAddress"
                style="color: red"
                class="b-text LableFontDesing"
              >
                {{ "**กรุณากรอกให้ครบทุกช่องเพื่อสมัครใช้บริการ" }}
              </label>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex shrink class="lg10 md12 xs12 sm12" px-3>
              <div style="max-width: 166px; max-height: 43px; float: right">
                <v-btn
                  block
                  depressed
                  :disabled="isdisablebutton"
                  @click="Add"
                  width="166px"
                  height="43px"
                  color="#a6cb3b"
                  class="buttonDesign"
                  style="color: White; text-transform: none"
                  >{{ "ลงทะเบียน" }}</v-btn
                >
              </div></v-flex
            >
          </v-layout>
        </v-col>
      </v-col>
    </v-row>
    <!-- </v-flex>
  </v-layout> -->
  </v-container>
</template>

<script>
import GlobalMixin from "./Mixins/GlobalMixin";
import axios from "axios";
import enurl from "@/api/environment";
import $ from "jquery";
export default {
  mixins: [GlobalMixin],
  name: "Modal",
  //props: {},
  data: () => ({
    title: null,
    //companyId: null,
    companyName: null,
    telephoneNumber: null,
    email: null,
    //editEmail: null,
    countryName: null,
    cityName: null,
    contactName: null,
    address: null,
    status: false,
    userName: null,
    userID: null,
    password: null,
    empID: null,
    abbreviation: null,
    cur_appr: null,
    check1: false,
    companyIndex: null,
    //.........
    oldAbbr: "",
    show1: false,
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match"
    },
    url: enurl.apiUrl,
    urlv4: enurl.apiUrlV4,
    warningModal: false,
    isSuccessModalVisible: false,
    text: null,
    dialog: false,
    password2: null,
    namecheck: false,
    phonecheck: false,
    mailcheck: false,
    countrycheck: false,
    priceplancheck: false,
    guestaccesscheck: false,
    useridcheck: false,
    passwordcheck: false,
    citycheck: false,
    contactnamecheck: false,
    addresscheck: false,
    abbrevCheck: false,
    checkalphabet: false,
    checkalphabet2: false,
    checknumber: false,
    phonenolength: false,
    echeck1: true,
    echeck2: true,
    isdisablebutton: false,
    packagenameList: [],
    activeemployeeList: [],
    numberoffileList: [],
    businesstypeList: [],
    countrytypeList: [],
    search: "",
    searchCountry: "",
    businesscheck: false,
    otherbusinesscheck: false,
    otheroptions: false,
    businessTypeID: 0,
    businessTypeOther: "",
    option: ""
  }),
  mounted: function() {
    let self = this;
    self.GetBusinessTypeList();
    self.GetCountryList();
    //let language = "th";
    // if (language == "en") {
    self.changeLocale("en", "us", "English", 1);
    // }
    // if (language == "th") {
    //   self.changeLocale("th", "th", "ไทย", 0);
    // }
  },
  watch: {
    oldAbbr: function() {
      let self = this;

      if (
        self.oldAbbr != 0 &&
        self.oldAbbr != 1 &&
        self.oldAbbr != 2 &&
        self.oldAbbr != 3 &&
        self.oldAbbr != 4 &&
        self.oldAbbr != 5 &&
        self.oldAbbr != 6 &&
        self.oldAbbr != 7 &&
        self.oldAbbr != 8 &&
        self.oldAbbr != 9
      ) {
        let tempKey = self.oldAbbr;
        axios
          .post(`${self.url}Company/CheckAbbre?abbre=${tempKey}`)
          .then(function(response) {
            if (response.data.status == 0) {
              self.check1 = true;
            } else {
              self.check1 = false;
            }
          })
          .catch(function(error) {
            alert(error);
          });
      }
    },
    businessTypeID: function() {
      this.businesscheck = false;
    },
    businessTypeOther: function() {
      this.otherbusinesscheck = false;
    },
    email: function() {
      let self = this;
      self.echeck2 = true;
    }
  },
  computed: {
    showField() {
      return this.businessTypeID === 30; //"อื่นๆ";
    },
    filteredNames() {
      return this.businesstypeList.filter(x =>
        x.thai_Name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    filteredThaiCountryNames() {
      return this.countrytypeList.filter(x =>
        x.thaiCountryName
          .toLowerCase()
          .includes(this.searchCountry.toLowerCase())
      );
    },
    abbr: {
      get() {
        return this.abbreviation;
      },
      set(v) {
        this.abbreviation = v;
        this.oldAbbr = v;
      }
    }
  },

  methods: {
    otheroptionstype() {
      return this.$t("enterbusiness");
    },
    handleOptionChange(option) {
      this.option = option;
    },
    searchInLists() {},
    isNumber(e) {
      this.checknumber = false;
      // Allow: backspace, delete, tab, escape, enter and .
      if (
        $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190, 17, 18, 16]) !== -1 ||
        // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
        ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) &&
          (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        this.checknumber = true;
        this.phonecheck = false;
        this.phonenolength = false;
        e.preventDefault();
      }
    },
    IsSpecialChar(e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if (
        $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 17, 18, 16]) !== -1 ||
        // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
        ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) &&
          (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey && e.keyCode >= 48 && e.keyCode <= 57) ||
        e.keyCode >= 144 ||
        e.keyCode == 190
      ) {
        e.preventDefault();
      }
    },
    IsSpecialCharAddress(e) {
      // Allow: backspace, delete, tab, escape, enter and .
      if (
        $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 17, 18, 16]) !== -1 ||
        // Allow: Ctrl+A,Ctrl+C,Ctrl+V, Command+A
        ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) &&
          (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right, down, up
        (e.keyCode >= 35 && e.keyCode <= 40)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey && e.keyCode >= 49 && e.keyCode <= 56) ||
        (e.shiftKey && e.keyCode == 190) ||
        (e.shiftKey && e.keyCode == 191) ||
        (e.shiftKey && e.keyCode == 188) ||
        e.keyCode == 187
      ) {
        e.preventDefault();
      }
    },

    checkAlphabet(event) {
      const validCharacters = /^[\u0020-\u007E]+$/; // /^[a-zA-Z0-9.]*$/;

      if (!validCharacters.test(event.key) && event.key.length === 1) {
        event.preventDefault();
        this.checkalphabet = true;
      } else {
        this.checkalphabet = false;
      }
    },

    onPaste(event) {
      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text"
      );
      // Allow only a-z, A-Z, 0-9, and . in pasted content
      const letterNumber = /^[a-zA-Z0-9.]+$/;
      if (!pastedText.match(letterNumber)) {
        event.preventDefault(); // Prevent pasting if content contains invalid characters
        this.checkalphabet = true;
      }
    },

    close() {
      this.$emit("close");
      this.checkalphabet2 = false;
      this.namecheck = false;
      this.checkalphabet = false;
      this.abbrevCheck = false;
      this.checkalphabet = false;
      this.checknumber = false;
      this.phonecheck = false;
      this.phonenolength = false;
      this.mailcheck = false;
      this.countrycheck = false;
      this.citycheck = false;
      this.contactnamecheck = false;
      this.addresscheck = false;
      this.priceplancheck = false;
      this.guestaccesscheck = false;
      this.useridcheck = false;
      this.passwordcheck = false;
      this.otherbusinesscheck = false;
    },
    ValidateEmail(email) {
      let re = /^(([^<>()[\]\\,;:\s@"]+(\.[^<>()[]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    GetBusinessTypeList() {
      let self = this;
      axios.get(`${self.url}Company/GetBusinessType`).then(function(response) {
        if (response.data.status == 0) {
          self.businesstypeList = response.data.data;
        }
      });
    },
    GetCountryList() {
      let self = this;
      axios.get(`${self.url}User/GetCountryList`).then(function(response) {
        if (response.data.status == 0) {
          self.countrytypeList = response.data.data;
        }
      });
    },
    Add() {
      let self = this;

      if (!self.validation_company_managementinformationweb()) {
        self.warningModal = true;
      }

      self.dialog = false;
      self.checknumber = false;
      let txt = self.CheckValidate();
      if (this.check1 === false) {
        //////////////Noted(Reopen)//////////////////////////////
        if (this.oldAbbr == "" || this.oldAbbr == null) {
          console.log("becasue of empty block statement");
        } else {
          alert(this.$t("abbre") + this.$t("AlreadyExit"));
        }
      } else {
        if (txt) {
          self.isdisablebutton = true;
          let temp = {
            companyName: self.companyName,
            telNo: self.telephoneNumber,
            email: self.email,
            country: "", //self.countryName,
            city: "", //self.cityName,
            contactname: self.contactName,
            address: "", //self.address
            status: true,
            createBy: "",
            createDate: null,
            empID: "0001",
            username: "",
            password: "",
            abb: self.oldAbbr,
            companyIndex: self.companyIndex,
            packageName: "PKG1001",
            activeEmpId: 1,
            numberOfFilesId: 1,
            businessType: "",
            businessTypeID: 30, //self.businessTypeID,
            businessTypeOther: "", //self.businessTypeOther,
            emailLanguage: "thai"
          };
          console.log("add data: ", temp);
          axios
            .post(`${self.url}Company/RegisterNewCompany`, temp)
            .then(function(response) {
              self.text = "Company added successfully.";
              self.isSuccessModalVisible = true;
              //  self.isdisablebutton = false;
              if (response.data.status == 0) {
                // alert(self.$t("RegisterSuccessful"));
                top.location = enurl.thankyouUrl;
              } else {
                alert(response.data.message);
              }
            })
            .catch(function(error) {
              self.dialog = false;
              self.isdisablebutton = false;
              alert(error);
            });
        }
      }
    },
    changeLocale(locale, flag, title, highlighted) {
      this.currentflag = flag;
      this.$i18n.locale = locale;
      this.currentLangTitle = title;
      this.lang = highlighted;
      document.cookie = "langprod=" + locale;
      document.cookie = "flagprod=" + flag;
      document.cookie = "titleprod=" + title;
      document.cookie = "highlighted=" + highlighted;
    },
    Reset() {
      let self = this;
      self.companyName = "";
      self.telephoneNumber = "";
      self.email = "";
      self.countryName = "";
      self.cityName = "";
      self.contactName = "";
      self.address = "";
      self.abbr = "";
    },
    CheckValidate() {
      let self = this;
      self.namecheck = true;
      self.phonecheck = true;
      self.checknumber = false;
      self.countrycheck = true;
      self.useridcheck = true;
      self.passwordcheck = true;
      self.mailcheck = true;
      self.citycheck = true;
      self.contactnamecheck = true;
      self.addresscheck = true;
      self.abbrevCheck = true;
      self.businesscheck = true;
      self.otherbusinesscheck = true;
      let retvalue = true;
      let abb = self.oldAbbr ? self.oldAbbr : self.abbreviation;
      if (self.companyName != "" && self.companyName != undefined) {
        self.namecheck = false;
      } else {
        retvalue = false;
      }

      if (abb != "" && abb != undefined) {
        self.abbrevCheck = false;
      } else {
        retvalue = false;
      }
      if (self.checkalphabet) {
        retvalue = false;
      }
      const pattern = /^[a-zA-Z0-9]+$/;
      let isValid = pattern.test(abb);

      if (isValid === false) {
        retvalue = false;
        this.checkalphabet = true;
      }

      if (self.telephoneNumber != "" && self.telephoneNumber != undefined) {
        self.phonecheck = false;
      } else {
        self.phonenolength = false;
        self.phonecheck = true;
        retvalue = false;
      }
      if (self.email != "" && self.email != undefined) {
        self.mailcheck = false;
        let aa = self.ValidateEmail(self.email);
        if (!aa) {
          retvalue = false;
          self.mailcheck = true;
        }
      } else {
        retvalue = false;
      }
      // if (self.countryName != "" && self.countryName != undefined) {
      //   self.countrycheck = false;
      // } else {
      //   retvalue = false;
      // }
      // if (self.cityName != "" && self.cityName != undefined) {
      //   self.citycheck = false;
      // } else {
      //   retvalue = false;
      // }
      if (self.contactName != "" && self.contactName != undefined) {
        self.contactnamecheck = false;
      } else {
        retvalue = false;
      }
      // if (self.address != "" && self.address != undefined) {
      //   self.addresscheck = false;
      // } else {
      //   retvalue = false;
      // }
      // if (self.businessTypeID != 0 && self.businessTypeID != undefined) {
      //   self.businesscheck = false;
      // } else {
      //   retvalue = false;
      // }
      // console.log("BSid", self.option);
      // if (self.option === 30) {
      //   if (
      //     self.businessTypeOther != "" &&
      //     self.businessTypeOther != undefined
      //   ) {
      //     self.otheroptions = true;
      //     self.otherbusinesscheck = false;
      //   } else {
      //     retvalue = false;
      //   }
      // } else {
      //   self.businessTypeOther = "";
      //   self.otherbusinesscheck = false;
      //   self.otheroptions = false;
      //   // console.log("otheroption", self.businessTypeOther);
      //   // console.log("Selected option id:", this.option);
      //   // console.log("Test empty", self.otherbusinesscheck);
      // }
      if (self.check1 === true) {
        console.log("becasue of empty block statement");
      } else {
        retvalue = false;
      }
      if (self.cur_appr != self.oldAbbr) {
        if (self.check1 === true) {
          console.log("becasue of empty block statement");
        } else {
          retvalue = false;
        }
      }
      if (self.echeck2 === false) {
        self.echeck1 = false;
        retvalue = false;
      }
      return retvalue;
    },
    getPackageDataList() {
      let self = this;
      axios
        .get(`${self.urlv4}Package/GetPackageMasterList`)
        .then(function(response) {
          if (response.data.status == 0) {
            self.packagenameList = response.data.data;
          }
        });
    },
    getActiveEmployeeList() {
      let self = this;
      axios
        .get(`${self.urlv4}Package/GetActiveEmpMasterList`)
        .then(function(response) {
          if (response.data.status == 0) {
            self.activeemployeeList = response.data.data;
          }
        });
    },
    getNumberOfFileList() {
      let self = this;
      axios
        .get(`${self.urlv4}Package/GetNumberOfFilesMasterList`)
        .then(function(response) {
          if (response.data.status == 0) {
            self.numberoffileList = response.data.data;
          }
        });
    }
    // localeCompanyName() {
    //   return this.$t("companyname");
    // },
    // localeAbbreviation() {
    //   return this.$t("abbre");
    // },
    // localeTelephone() {
    //   return this.$t("telephoneno");
    // },
    // localeEmail() {
    //   return this.$t("email");
    // },
    // localeCountry() {
    //   return this.$t("country");
    // },
    // localeCity() {
    //   return this.$t("city");
    // },
    // localeContactName() {
    //   return this.$t("contactname");
    // },
    // localeAddress() {
    //   return this.$t("address");
    // },
    // localeStatus() {
    //   return this.$t("status");
    // },
  }
};
</script>

<style scoped>
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
  .ipad_res {
    display: inline-block;
  }
}
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
  .ipadpro_res {
    padding-left: 5rem !important;
  }
}
/* .container {
  max-height: 100vh;
  overflow: hidden;
  padding-top: 0px;
  background-color: #f3f6fb;
  max-width: 100%;
} */
.container {
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 0;
  background-color: #f3f6fb;
  max-width: 100%;
  box-sizing: border-box;
}
.modal {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  overflow-y: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}
.buttonDesign {
  font-family: "Kanit", sans-serif;
}
.modal-content {
  background-color: #fefefe;
  margin: 5% auto;
  padding: 30px 40px 15px 40px;
  border: 1px solid #888;
  width: 55%;
  border-radius: 25px;
}
@media only screen and (max-width: 600px) {
  .modal-content {
    width: 90%;
    padding: 30px 20px 15px 20px;
  }
}
.modal-content .close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}
.modal-content .close:hover,
.modal-content .close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}
.columntextcolor {
  color: #a6cc39;
  font-size: 35px;
  font-family: "Kanit", sans-serif;
}

.form-group label {
  color: #43425d;
}
.form-group input,
.input-group input {
  /* color: rgba(77, 79, 92, 0.4);  */
  border: 1px solid #e8e9ec;
}
.form-group textarea,
.input-group textarea {
  /*  color: rgba(77, 79, 92, 0.4); */
  border: 1px solid #e8e9ec;
}
.LableFontDesing {
  font-size: 18px;
  font-weight: 400;
  font-family: "Kanit", sans-serif;
}
.LablePlaceHolder {
  font-size: 15px;
  font-weight: 200;
  font-family: "Kanit", sans-serif;
}
.review-box {
  position: relative;
  margin-left: 25px;
  margin-right: 15px;
  padding: 30px 40px;
  border: 1px solid #ecebee;
  font-size: 4rem;
  border-radius: 4px;
}
.review-box i {
  color: rgba(67, 66, 93, 0.2);
}
.review-box .close {
  position: absolute;
  top: -10px;
  right: -10px;
  float: right;
}
.review-box .close i {
  font-size: 28px;
  color: #eb2127;
}
.review-box .close:hover i {
  color: #eb2127;
}

.modal-footer button {
  outline: none;
}
select {
  border: 1px solid #e8e9ec;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  padding-left: 10px;
}

@media only screen and (max-width: 414px) {
  .mobile-password {
    margin-left: -7px !important;
  }
}

@media only screen and (max-width: 375px) {
  .mobile-password {
    margin-left: 0 !important;
  }
}
</style>
<style>
.modal {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.modal::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
.v-input--selection-controls.v-input .v-label {
  margin-top: 8px !important;
}
</style>
